import React from 'react';
// Components
import RichTextRenderer from '../richTextRenderer';

interface timeline {
  data: {
    timelineType: string;
    events: Array<{ body: string; extraClasses?: string }>;
    extraClasses?: string;
  };
}
function Timeline({ data }: timeline) {
  const { timelineType, events, extraClasses } = data;

  return (
    <ul
      className={`cl-timeline ${timelineType === 'Horizontal' ? 'cl-timeline--horizontal' : ''} ${
        extraClasses ? extraClasses : ''
      }`}
    >
      {events.map((event, index: number) => {
        return (
          <li
            className={`cl-timeline__event ${event.extraClasses ? event.extraClasses : ''}`}
            key={index}
          >
            <RichTextRenderer text={event.body} />
            <span className='cl-timeline__line'></span>
            <span className='cl-timeline__dot'></span>
          </li>
        );
      })}
    </ul>
  );
}

export default Timeline;
